import $ from 'jquery'

function setCurrentUser () {
  $.ajax({
    url: '/yuncai/ebvplogin',
    method: 'get',
    dataType: 'json',
    contentType: 'application/json',
    success (data) {
      localStorage.setItem('user', JSON.stringify(data))
    }
  })
}

function getCurrentUser () {
  var user = localStorage.getItem('user')
  if (user) {
    user = JSON.parse(user)
    return user.user || user
  } else {
    $.ajax({
      url: '/yuncai/ebvplogin',
      type: 'get',
      async: false,
      success: function (data) {
        user = data.user
        localStorage.setItem('user', data)
      }
    })
    return user
  }
}

function getEnterpriseId () {
  var user = getCurrentUser()
  if (user) {
    try {
      return user.enterpriseId
    } catch (e) {
      console.error('getEnterpriseId Error: ' + e)
      return null
    }
  }
  return null
}

export {
  setCurrentUser,
  getCurrentUser,
  getEnterpriseId
}



// WEBPACK FOOTER //
// ./src/base/util/userContext.js